import { render, staticRenderFns } from "./TemplateSmallCard.vue?vue&type=template&id=12b067c0&scoped=true"
import script from "./TemplateSmallCard.vue?vue&type=script&lang=js"
export * from "./TemplateSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b067c0",
  null
  
)

export default component.exports